import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router';
import { Logo } from '@/components/common';
import { Button } from '@/components/ui/button';

/** Pantalla de error de las rutas: mejor que una página en blanco. */
export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  console.error(error);
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-4 p-6 text-center">
      <Logo withText={false} />
      <h1 className="font-display text-3xl">{t('errorPage.title')}</h1>
      <p className="max-w-md text-ink-2">{t('errorPage.body')}</p>
      <div className="flex gap-2">
        <Button variant="primary" onClick={() => window.location.reload()}>
          {t('errorPage.reload')}
        </Button>
        <Button asChild>
          <Link to="/">{t('notFound.home')}</Link>
        </Button>
      </div>
    </main>
  );
}
